import React from 'react';
import { cx } from '@emotion/css';
import * as styles from '../Class/batches.style.js';
// import "./batches.css";
import Amplify, { Auth } from 'aws-amplify';
import EditBatchIcon from '../../assets/images/edit-batch.png';
import MailIcon from '../../assets/images/email.png';
import { Hint } from 'react-autocomplete-hint';
import Select from 'react-select';
import { selectMedium } from '../../styles/components/forms.style';
import './FeedBackPopup.css'; // New import for CSS

function FeedBackPopup(props) {
    const [feedback, setFeedback] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [status, setStatus] = React.useState('Send Feedback');
    const categorytypes = [
        'Wrong Meaning',
        'Wrong Example',
        'Wrong Answer',
        'Question not clear',

    ];
    const [checks, setChecks] = React.useState('');

    const getToken = async () => {
        Auth.currentSession().then((res) => {
            //console.log("Auth.currentSession()")
            let accessToken = res.getAccessToken();
            ////console.log("accessToken called ")
            let jwt = accessToken.getJwtToken();
            ////console.log("Got jwt ")
            let useremail = Auth.user.attributes.email;
            ////console.log(useremail)
            sendFeedBack(Auth.user.username, useremail, jwt);



        });
    };

    const sendFeedBack = async (username, useremail, jwt) => {
        const id = Date.now();
       
        setStatus('Sending Feedback...');
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: jwt },

            body: JSON.stringify({
                sender: "admin@quizwizard.net",
                recipient: "mathforminds@gmail.com",
                username: username,
                email: useremail,
                question: props["presentquestion"],
                feedback: feedback,
                category: props["eventname"]
            }),
        };
        ////console.log(requestOptions)
        const response = await fetch(
            `https://api.quizwizard.net/quiz/sendemail`,
            requestOptions
        );
        const data = await response.json();
        // console.log(data)
        // console.log(props["presentquestion"].id)
        // console.log(props["presentquestion"].question)

        props.selected();

    };

    function createbatch() {
        getToken();
    }

    return (
        <div className="mypopup-box">
            <div className="mybox rounded-corners"> {/* Updated class name */}
                {checks}
                <span className="close-icon" onClick={props.handleClose}>
                    &#10005;
                </span>
                <div className={cx(styles.editBatchesMain)}>

                    <img src={MailIcon} alt="" />

                    <h3>FeedBack</h3>

                    <div className="add-item-box">
                        <input
                            name="feedback"
                            type="text"
                            spellCheck="false"
                            autoComplete="off"
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                            placeholder="feedback please"
                            required
                        />
                    </div>


                    <div className="add-item-box">
                        <span className="custom-dropdown"> {/* Updated class name */}
                            <Select
                                name="category"
                                className={selectMedium}
                                classNamePrefix="select"
                                value={category.length && { label: category, value: category }}
                                placeholder="Category"
                                onChange={(e) => setCategory(e.value)}
                                options={categorytypes.map((questiontype) => ({
                                    label: questiontype,
                                    value: questiontype,
                                }))}
                            />
                        </span>
                    </div>
                    <button className="createeventbutton" onClick={createbatch} > {/* Updated class name */}
                        {status}
                    </button>
                </div>
            </div>
        </div>

    );
}

export default FeedBackPopup;
